/* REST WEBSERVICE ABSTRACTION ************************************************/

import {
  toDataUrl,
  get,
  post,
  del,
  put,
  UberPromise,
  addRequestMiddleware,
  formatParams,
  CONTENT_TYPE

} from './utils'


/* Middleware to add api prefix to all request urls */
//addRequestMiddleware((request) => { request.url = 'api/'+request.url })

/* LOGIN **********************************************************************/

/**
* Login User
* @param credentials { email, password }
*/
export function login(credentials) {
  return post('api/users/login', credentials)
}

/**
* Retrieve the login state and metadata of the currently logged in user
* @return requestPromise (Promise with additional progress hook)
*/
export function getUserState() {
  return get('api/users/status')
}

/**
* Logout User
* @return requestPromise (Promise with additional progress hook)
*/
export function logout() {
  return post('api/users/logout')
}

/**
* Change User name
* @param userdata {name, surname} string
* @return requestPromise (Promise with additional progress hook)
*/
export function updateUserName(userdata) {
  return put('api/user/change_name', userdata)
}

/**
* Change User password
* @param userdata {name, surname} string
* @return requestPromise (Promise with additional progress hook)
*/
export function updateUserPassword(userdata) {
  return put('api/user/change_password', userdata)
}

/**
* Request a token to reset the user password. Server will respond by sending an
* email
* @param credentials { email } email string
* @return requestPromise (Promise with additional progress hook)
*/
export function requestPasswordResetToken(credentials) {
  return post('api/users/init_reset_password', credentials)
}

/**
* Reset user pwd using one shot token sent via email by the server
* @param ticket { token, newPassword } token string & newPassword string
* @return requestPromise (Promise with additional progress hook)
*/
export function resetPassword(ticket) {
  return post('api/users/reset_password', ticket)
}

/* ORGA ***********************************************************************/

/**
* Retrieve schedule state
* @param userdata {name, surname} string
* @return requestPromise (Promise with additional progress hook)
*/
export function getOrganizationConfig() {
  //console.log("GET apiv2/organization/config")
  return get('apiv2/organization/config')
}

/**
* Change User name
* @param userdata {name, surname} string
* @return requestPromise (Promise with additional progress hook)
*/
export function updateOrganizationConfig(config) {
  //console.log("PUT apiv2/organization/config")
  return put('apiv2/organization/config', config)
}


/* ASSET **********************************************************************/

/**
* Retrieve all Assets
* @return requestPromise (Promise with additional progress hook)
* @todo rethink strategy
*/
export function getAssets(params) {
  return get('api/assets/list'+formatParams(params))
}

/**
* Retrieve a single Asset
* @param query { id } id string
* @return requestPromise (Promise with additional progress hook)
*/
export function getAsset(query) {
  return get('api/asset/'+query.uid)
}

/**
* @deprecated
* Retrieve Assets Stats
* Stats contains metadata such as usage count, created and modified dates
* @return requestPromise (Promise with additional progress hook)
*/
export function getAssetsStats() {
  return get('api/assets/stats')
}

/**
* @deprecated
* Retrieve Stats of a single Asset
* Stats contains metadata such as usage count, created and modified dates
* @param id string
* @return requestPromise (Promise with additional progress hook)
*/
export function getAssetStats(id) {
  return get('api/asset/'+id+'/stats')
}

/**
* @deprecated
* Retrieve a single Assets MetaData
* MetaData contains name
* @param id string
* @return requestPromise (Promise with additional progress hook)
*/
export function getAssetMetaData(id) {
  return get('api/asset/'+id+'/metadata')
}

/**
* Update MetaData of a single Asset
* MetaData contains name
* @param id string
* @return requestPromise (Promise with additional progress hook)
*/
export function updateAssetMetaData(query) {
  return put('api/asset/'+query.uid+'/metadata', query.data)
}

/**
* Upload Asset binary data
* @param file binary
* @return requestPromise (Promise with additional progress hook)
*/
export function uploadAsset(file) {
  return post(
    'api/asset/' + btoa(unescape(encodeURIComponent(file.name))),
    file,
    {
      header: {'File-Size': file.size, 'Content-Type': CONTENT_TYPE.BINARY}


    }
  )
}

/**
* Remove Asset
* @param id string
* @return requestPromise (Promise with additional progress hook)
*/
export function removeAsset(query) {
  return del('api/asset/'+query.uid)
}

/* PLAYLIST *******************************************************************/

/**
* Retrieve all Playlists
* @return requestPromise (Promise with additional progress hook)
* @todo rethink strategy
*/
export function getPlaylists(params) {
  return get('apiv2/playlists/list'+formatParams(params))
}

/**
* Retrieve stats of all Playlists
* @return requestPromise (Promise with additional progress hook)
* @todo rethink strategy
*/
export function getPlaylistsStats() {
  return get('api/playlists/stats')
}

/**
* Retrieve stats of a single Playlist
* @param id string
* @return requestPromise (Promise with additional progress hook)
*/
export function getPlaylistStats(id) {
  return get('api/playlist/'+id+'/stats')
}

/**
* Retrieve a single Playlist
* @param id string
* @return requestPromise (Promise with additional progress hook)
*/
export function getPlaylist(query) {
  return get('apiv2/playlist/'+query.uid)
}

/**
* Add a new Playlist
* @param opts string
* {
*   name: name,
*   tags: [],
*   mediaObjects: [],
*   timeConstraint :  {
*     startTime: null,
*     stopTime:  null
*   }
* }
* @return requestPromise (Promise with additional progress hook)
*/
export function addPlaylist(opts) {
  return post('apiv2/playlist', opts)
}

/**
* Update a new Playlist
* @param opts object
* {
*   uid: string,
*   item: {
*     name: name,
*     tags: [],
*     mediaObjects: [],
*     timeConstraint :  {
*       startTime: null,
*       stopTime:  null
*     }
*   }
* }
* @return requestPromise (Promise with additional progress hook)
*/
export function updatePlaylist(opts) {
  return put('apiv2/playlist/'+opts.uid, opts.item)
}

/**
* Remove Playlist
* @param id string
* @return requestPromise (Promise with additional progress hook)
*/
export function removePlaylist(query) {
  return del('apiv2/playlist/'+query.uid)
}

/* MEDIA PLAYER ***************************************************************/

/**
* Retrieve all MediaPlayers
* @return requestPromise (Promise with additional progress hook)
* @todo rethink strategy
*/
export function getMediaPlayers(params) {
  //return get('mediaplayers'+formatParams(params))
  return get('api/mediaplayers/list'+formatParams(params))
}

/**
* Retrieve a single mediaplayer
* @param id string
* @return requestPromise (Promise with additional progress hook)
*/
export function getMediaPlayer(query) {
  return get('api/mediaplayer/'+query.uid)
}


/**
* DEPRECATED
* Retrieve a list of all mediaplayers that are currently online
* @return requestPromise (Promise with additional progress hook)
*/
export function getOnlineMediaPlayers() {
  return get('api/mediaplayers/status')
}

/**
* Retrieve a list of all mediaplayers that are currently online
* @return requestPromise (Promise with additional progress hook)
*/
export function getMediaPlayersStatus() {
  return get('api/mediaplayers/status')
}

/**
* Retrieve a list of all mediaplayers that are currently online
* @return requestPromise (Promise with additional progress hook)
*/
export function getMediaPlayerStatus(query) {
  return get('api/mediaplayer/'+query.uid+'/status')
}

/**
* Update MediaPlayer metadata
* @param id string
* @param name string
* @param description string
* @param tags array
* @return requestPromise (Promise with additional progress hook)
* @todo pack args as opts
*/
export function updateMediaPlayer(opts) {
  return put('api/mediaplayer/'+opts.uid, opts.item)
}

/**
* Take a snapshot with the built in camera and retrieve it
* @param id string
* @return requestPromise (Promise with additional progress hook)
*/
export function getMediaPlayerCameraImage(query) {
  return get(
    'api/mediaplayer/'+query.uid+'/monitoring/camera',
    null,
    {
      responseType: 'arraybuffer',
      responseTransform: (request) => {
        request.response = toDataUrl(request.response)
      }
    }
  )
}

/**
* Retrieve the current graphicscard output of the given mediaplayer
* @param id string
* @return requestPromise (Promise with additional progress hook)
*/
export function getMediaPlayerGraphicsOutputImage(query) {
  return get(
    'api/mediaplayer/'+query.uid+'/monitoring/graphics-output',
    null,
    {
      responseType: 'arraybuffer',
      responseTransform: (request) => {
        request.response = toDataUrl(request.response)
      }
    }
  )
}

/**
* Synchronize the given media player. Apply all changes made before and instruct
* EDGE MediaPlayer to download all assets.
* @param id string
* @return requestPromise (Promise with additional progress hook)
*/
export function syncMediaPlayer(opts) {
  return post('api/sync/'+opts.uid)
}

/**
* Synchronize the given media player. Apply all changes made before and instruct
* EDGE MediaPlayer to download all assets.
* @param opts object
* @param opts.filter filter string
* @return requestPromise (Promise with additional progress hook)
*/
export function bulkSyncMediaPlayer(opts) {
  return post('api/sync'+formatParams({filter: opts.filter}))
}


/* BOOKING ********************************************************************/

/**
* Fetch the surfaces defined on the given device. Required after changes made
* using the iPad App.
* @param id string
* @return requestPromise (Promise with additional progress hook)
*/
export function syncMediaPlayerSurfaces(opts) {
  return post('api/bookings/'+opts.uid+'/sync-surfaces')
}

/**
* Fetch all surfaces of the given media player
* @param mediaplayerId string
* @return requestPromise (Promise with additional progress hook)
*/
export function getSurfaces(query) {
  return get('api/bookings/'+query.uid)
}

/**
* Fetch a specific surface of the given media player
* @param mediaplayerId string
* @param surfaceId string
* @return requestPromise (Promise with additional progress hook)
*/
export function getSurface(query) {
  return get('api/booking/'+query.mediaPlayerId+'/'+query.surfaceId)
}

/**
* Update a surface. Write data like assigned playlist an surface name
* @param mediaplayerId string
* @param surfaceId string
* @param surface object
* @return requestPromise (Promise with additional progress hook)
*/
export function updateSurface(opts) {
  return put('api/booking/'+opts.mediaPlayerId+'/'+opts.surfaceId, opts.surface)
}


/**
* UNFORTUNATELY DEPRECATED. API METHOD GONE
* Update all surfaces 0f a media player
* @param opts object
* @param opts.mediaplayerId string
* @param opts.surfaces array
* @return requestPromise (Promise with additional progress hook)
*/
export function updateSurfaces(opts) {
  return put('api/bookings/'+opts.mediaPlayerId, opts.surfaces)
}


/**
* Update a surface. Write data like assigned playlist an surface name
* @param opts object
* @param opts.filter filter string
* @param opts.playlistId
* @return requestPromise (Promise with additional progress hook)
*/
export function bulkAssignPlaylist(opts) {
  return put('api/booking'+formatParams({filter: opts.filter}), {playlistId: opts.playlistId})
}

/* VIRTUAL ********************************************************************/

export function getLanguage() {
  return UberPromise((resolve, reject, progress) => {
    let language = localStorage.getItem("language") || "de"
    if (language) {
      language = language.replace(/"|'/g, '')
    }
    resolve(language)
  })
}

export function updateLanguage(value) {
  return UberPromise((resolve, reject, progress) => {
    if(value) {
      resolve(localStorage.setItem("language", value))
    }
  })
}

export function getCookieOptIn() {
  return UberPromise((resolve, reject, progress) => {
    resolve(JSON.parse(localStorage.getItem("cookieOptIn")))
  })
}

export function updateCookieOptIn(value) {
  return UberPromise((resolve, reject, progress) => {
    resolve(localStorage.setItem("cookieOptIn", JSON.stringify(value)))
  })
}

// Asset

export function getAssetFilter() {
  return UberPromise((resolve, reject, progress) => {
    let filter
    try {
      filter = JSON.parse(localStorage.getItem("assetFilter"))
      resolve(filter)
    } catch (err) {
      reject(err)
    }
  })
}

export function updateAssetFilter(value) {
  return UberPromise((resolve, reject, progress) => {
    try {
      localStorage.setItem("assetFilter", JSON.stringify(value))
      resolve()
    } catch (err) {
      reject(err)
    }
  })
}

export function getAssetSort() {
  return UberPromise((resolve, reject, progress) => {
    let sort
    try {
      sort = JSON.parse(localStorage.getItem("assetSort"))
      resolve(sort)
    } catch (err) {
      reject(err)
    }
  })
}

export function updateAssetSort(value) {
  return UberPromise((resolve, reject, progress) => {
    try {
      localStorage.setItem("assetSort", JSON.stringify(value))
      resolve()
    } catch (err) {
      reject(err)
    }
  })
}

// Playlist
export function getPlaylistFilter() {
  return UberPromise((resolve, reject, progress) => {
    let filter
    try {
      filter = JSON.parse(localStorage.getItem("playlistFilter"))
      resolve(filter)
    } catch (err) {
      reject(err)
    }
  })
}

export function updatePlaylistFilter(value) {
  return UberPromise((resolve, reject, progress) => {
    try {
      localStorage.setItem("playlistFilter", JSON.stringify(value))
      resolve()
    } catch (err) {
      reject(err)
    }
  })
}

export function getPlaylistSort() {
  return UberPromise((resolve, reject, progress) => {
    let sort
    try {
      sort = JSON.parse(localStorage.getItem("playlistSort"))
      resolve(sort)
    } catch (err) {
      reject(err)
    }
  })
}

export function updatePlaylistSort(value) {
  return UberPromise((resolve, reject, progress) => {
    try {
      localStorage.setItem("playlistSort", JSON.stringify(value))
      resolve()
    } catch (err) {
      reject(err)
    }
  })
}

// Media Player
export function getMediaPlayerFilter() {
  return UberPromise((resolve, reject, progress) => {
    let filter
    try {
      filter = JSON.parse(localStorage.getItem("mediaPlayerFilter"))
      resolve(filter)
    } catch (err) {
      reject(err)
    }
  })
}

export function updateMediaPlayerFilter(value) {
  return UberPromise((resolve, reject, progress) => {
    try {
      localStorage.setItem("mediaPlayerFilter", JSON.stringify(value))
      resolve()
    } catch (err) {
      reject(err)
    }
  })
}

export function getMediaPlayerSort() {
  return UberPromise((resolve, reject, progress) => {
    let sort
    try {
      sort = JSON.parse(localStorage.getItem("mediaPlayerSort"))
      resolve(sort)
    } catch (err) {
      reject(err)
    }
  })
}

export function updateMediaPlayerSort(value) {
  return UberPromise((resolve, reject, progress) => {
    try {
      localStorage.setItem("mediaPlayerSort", JSON.stringify(value))
      resolve()
    } catch (err) {
      reject(err)
    }
  })
}

// Global filter

export function getGlobalFilter() {
  return UberPromise((resolve, reject, progress) => {
    let filter
    try {
      filter = JSON.parse(localStorage.getItem("globalFilter"))
      resolve(filter)
    } catch (err) {
      reject(err)
    }
  })
}

export function updateGlobalFilter(value) {
  return UberPromise((resolve, reject, progress) => {
     try {
      localStorage.setItem("globalFilter", JSON.stringify(value))
      resolve()
    } catch (err) {
      reject(err)
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/api/index.js